<template>
  <div class="mt-6 mt-md-8">
    <v-alert color="secondary" type="info" width="100%">
      {{ text }}
    </v-alert>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
  },
};
</script>
